export default __webpack_public_path__ + "static/media/171.637f3bf3.svg";